import { useExperiment } from '../../../common/ExperimentContext/useExperiment';
import { SuggestionsExperiment } from '../../components/SearchHeader/Suggestions/SuggestionsExperiment/SuggestionsExperiment';
import { SearchHeaderV1 } from './SearchHeaderV1/SearchHeaderV1';
import { SearchHeaderV2 } from './SearchHeaderV2/SearchHeaderV2';
import { SearchPromotionItem } from './Suggestions/EmptySearchSuggestions/SearchPromotionResponse.type';

export interface Props {
  placeholder?: string;
  disableSearch?: boolean;
  showLoginDropdown?: boolean;
  compactSearch?: boolean;
  searchSpecialty?: SearchPromotionItem | null;
  onClear?: VoidFunction;
  showSearchExperiment?: boolean;
  hideLogo?: boolean;
  practitionerProfile?: boolean;
}

export const SearchHeader = (searchHeaderProps: Props) => {
  const showSearchExperiment = searchHeaderProps.showSearchExperiment;

  const isSuggestionsExperiment = useExperiment(SuggestionsExperiment(showSearchExperiment)).data;

  if (isSuggestionsExperiment && showSearchExperiment) {
    return <SearchHeaderV2 {...searchHeaderProps} />;
  } else {
    return <SearchHeaderV1 {...searchHeaderProps} />;
  }
};
